import React from "react";
import { Box, Typography, Button } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import "../assets/styles/global.css";
import { Link } from "react-router-dom"; // Assuming you're using React Router for navigation

const UnderConstruction = () => {
  return (
    <Box sx={{ flexGrow: 1, padding: "2rem", textAlign: "center" }}>
      <Box
        sx={{
          padding: "3rem",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          backgroundColor: "#f5f5f5",
        }}
      >
        <Typography
          variant="h4"
          sx={{ marginBottom: "1rem", fontWeight: "bold" }}
          fontFamily={"Georgia"}
        >
          This Page is Still Being Designed
        </Typography>
        <Typography
          variant="body1"
          sx={{ marginBottom: "2rem", fontSize: "1.2rem" }}
          fontFamily={"Arial"}
        >
          We are working hard to bring you the best experience. Stay tuned for
          more updates!
        </Typography>
        <Grid2 container spacing={2} justifyContent="center">
          <Grid2 size={6} sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              component={Link}
              to="/"
              sx={{
                padding: "0.8rem 2rem",
                background: "black",
                color: "#fff",
              }}
            >
              Go Back to Home
            </Button>
          </Grid2>
        </Grid2>
      </Box>
    </Box>
  );
};

export default UnderConstruction;
